import { cookies } from '@/shared/lib/cookies';
import _ from 'lodash';
import LINK_CONFIG from './env';

/**
 * Builds the Amplify configuration of the Mercy tenant portal. Spreads the environment's AWS exports, overrides the OAuth redirects with the configured link and nests an Auth block whose cookie storage targets localhost or the environment domain with a one-year strict cookie that is secure only off localhost.
 *
 * @returns Amplify configuration object for the Mercy portal.
 */
const updatedAwsConfig = () => ({
  ...LINK_CONFIG.AWS_CONFIG,
  oauth: {
    ...LINK_CONFIG.AWS_CONFIG.oauth,
    redirectSignIn: LINK_CONFIG.LINK_REDIRECT_AWS,
    redirectSignOut: LINK_CONFIG.LINK_REDIRECT_AWS,
  },
  Auth: {
    ...LINK_CONFIG.AWS_CONFIG,
    cookieStorage: {
      domain: cookies.getDomain(),
      path: '/',
      expires: 365,
      sameSite: 'strict',
      secure: !_.includes(window.location.hostname, 'localhost'),
    },
  },
});

export default updatedAwsConfig;
